import { phoneNumberZodSchema } from "@@/shared/phone";
import type { Except } from "type-fest";
import { z } from "zod";
import { generateId } from "../../../../utilities/generate-id";
import type {
    IsoAndUnixTimestamp} from "../../../date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "../../../date-time/iso-and-unix";
import { idZodSchema } from "../../../id";

type PhoneSignInInitiateCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "PHONE_SIGN_IN_INITIATE_COMMAND";
    readonly phoneNumber: string;
    readonly signUpId: string;
};

type CommandParams = Except<
    PhoneSignInInitiateCommand,
    "_id" | "_type" | "_createdAt"
>;
const createPhoneSignInInitiateCommand = (params: CommandParams) => {
    const phoneSignInInitiateCommand: PhoneSignInInitiateCommand = {
        ...params,
        _id: generateId({ prefix: "phone_sign_in_initiate_command__" }),
        _type: "PHONE_SIGN_IN_INITIATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return phoneSignInInitiateCommand;
};

const phoneSignInInitiateCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("PHONE_SIGN_IN_INITIATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    phoneNumber: phoneNumberZodSchema,
    signUpId: z.string(),
});

export {
    createPhoneSignInInitiateCommand,
    phoneSignInInitiateCommandZodSchema,
};
export type {
    CommandParams as CreatePhoneSignInInitiateCommandParams,
    PhoneSignInInitiateCommand,
};
